module.exports = __webpack_public_path__ + "static/media/icon_favourites_add_600×558.aa671744.png";